import { CartContext } from "@repo/contexts/CartContext";
import { useSnackbarHandler } from "@repo/lib/hooks/common";
import { useAddToWishlistEvent } from "@repo/lib/hooks/gtm";
import { useTrackAddToWishlist } from "@repo/lib/hooks/webengage";
import { moveToWishlist } from "@repo/server-actions/cart";
import { useLocale, useTranslations } from "next-intl";
import { useCallback, useContext, useTransition } from "react";

const useMoveToWishlist = (item) => {
  const locale = useLocale();
  const [isPending, startTransition] = useTransition();
  const { handleAddToWishlistEvent } = useAddToWishlistEvent();
  const { trackAddToWishlistEvent } = useTrackAddToWishlist();
  const { setCartTotalsInfo } = useContext(CartContext);
  const t = useTranslations("Cart");
  const { showSnackbar } = useSnackbarHandler();

  const handleMoveItemToWishlist = useCallback(
    async (id) => {
      startTransition(async () => {
        const response = await moveToWishlist(id, locale);
        if (response?.success) {
          setCartTotalsInfo(response);
          handleAddToWishlistEvent(item);
          trackAddToWishlistEvent(item, true);
        }
        showSnackbar(response);
      });
    },
    [
      setCartTotalsInfo,
      locale,
      handleAddToWishlistEvent,
      item,
      showSnackbar,
      trackAddToWishlistEvent,
    ]
  );

  return {
    handleMoveItemToWishlist,
    isPending,
    t,
  };
};

export default useMoveToWishlist;
